<app-view-dashboard-component>
  @for (section of sections; track section.title) {
    <h2>{{ section.title | translate }}</h2>
    @for (item of section.items; track item.route) {
      <ion-item lines="none" [routerLink]="item.route" button="true">
        <ion-icon slot="start" [name]="item.icon"></ion-icon>
        {{ item.name | translate }}
      </ion-item>
    }
  }
</app-view-dashboard-component>
